import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import 'assets/scss/material-dashboard-pro-react.css?v=1.4.0';
import App from './App';

const rootElement = document.getElementById('root');

function render() {
  ReactDOM.render(
    <AppContainer>
      <App />
    </AppContainer>,
    rootElement
  );
}

render();

if (module.hot) {
  module.hot.accept('./App', () => {
    render();
  });
}



// WEBPACK FOOTER //
// ./src/index.js